import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { OSD_LOG_NEW, GET_USER_EMAIL } from 'src/app/onelog/common/config/url';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';
import { DropDownComponent } from 'src/app/onelog/common/fields/drop-down/drop-down.component';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {
  NEW_DROP_DOWN_LIST_BOOK_TYPE,
  DROP_DOWN_SETTING_BOOKTYPE,
} from 'src/app/onelog/common/config/dropdown-config';

@Component({
  selector: 'app-osd-log-new',
  templateUrl: './osd-log-new.component.html',
  styleUrls: ['./osd-log-new.component.css']
})
export class OsdLogNewComponent implements OnInit{

  constructor(private _requestService: RequestService, private _productStatus: ProductSatusService){}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  productId: string = '';
  userId: string = '';
  userEmail:string='';
  userData: any = '';
  datesData: any = '';
  publishedDatesData: any = [];
  selectedChangeDate: string = 'last 1 year';
  selectedPublishedDate: string = '';
  dropdownListPortfolioDirector: any[] = [];
  selectedPortfolioDirector: any[] = [];
  dropdownListProjectManager: any[] = [];
  selectedProjectManager: any[] = [];
  dropdownListVertical: any[] = [];
  selectedVertical: any[] = [];
  private readonly EXCLUDED_STATUSES: string[] = [
    'Draft', 'Expired', 'Committed', 'Cancelled', 'Terminated',
    'New Proposal', 'Removed_From_Sale', 'AE_Assigned',
    'Submitted Proposal', 'Published', 'Inactive',
  ];
  listStatus: any = [];
  dropdownListStatus: any = [];
  selectedStatus: any = [];
  dropdownListProductType: any = [];
  selectedProductType: any = [];
  dropdownListBookType: any = [];
  selectedBookType: any = [];
  dropdownSettings: IDropdownSettings = {};
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent!: QueryList<DropDownSingleSelectComponent>;
  @ViewChildren(DropDownComponent)
  DropDownComponents!: QueryList<DropDownComponent>;

  ngOnInit(): void {
    this.intializeData();
    this.loadProductStatusList();

    this.dropdownSettings = DROP_DOWN_SETTING_BOOKTYPE;
    this.dropdownListProductType = [
      { item_id: 1, item_text: 'Book' },
      { item_id: 2, item_text: 'Video' },
      { item_id: 3, item_text: 'Course' },
      { item_id: 4, item_text: 'Practice Exam' },
      { item_id: 5, item_text: 'AudioBook' },
      { item_id: 6, item_text: 'Tech Sessions' },
      { item_id: 7, item_text: 'Exam Trainer' },
    ];
    this.dropdownListBookType = NEW_DROP_DOWN_LIST_BOOK_TYPE;

    this.dropdownListVertical = [
      { item_id: 1, item_text: 'Amazon' },
      { item_id: 2, item_text: 'Cybersecurity' },
      { item_id: 3, item_text: 'Data Engineering' },
      { item_id: 4, item_text: 'Data Science' },
      { item_id: 5, item_text: 'Embedded Systems Development' },
      { item_id: 6, item_text: 'Game Development' },
      { item_id: 7, item_text: 'Tech Leaders' },
      { item_id: 8, item_text: 'Software Engineering and Architecture' },
      { item_id: 9, item_text: 'Systems Administration and Networking' },
      { item_id: 10, item_text: 'Tech Powered Pro' },
      { item_id: 11, item_text: 'Web & Application Development' },
      { item_id: 12, item_text: 'LLM Engineering' },
    ];

    this.datesData = [
      'current week',
      'last week',
      'current month',
      'last month',
      'last 2 months',
      'last 3 months',
      'last 6 months',
      'current year',
      'last year',
      'last 1 year',
      'last 2 years',
      'last 3 years',
    ];
    this.publishedDatesData = [
      'current_week',
      'last_week',
      'current_month',
      'last_month',
      'current_year',
      'last_year',
      'last_3_months',
      'last_6_months',
      'last_3_years',
    ];
  }

  loadProductStatusList() {
    return this._productStatus.getStatusList().subscribe((data: {}) => {
      this.listStatus = data;
      let statusList: any = [];
      this.listStatus.data.forEach((currentValue: any) => {
        let obj: any = {};
        obj['item_id'] = currentValue.attributes.name;
        obj['item_text'] = currentValue.attributes.name;
        statusList.push(obj);
      });
      this.dropdownListStatus = statusList;
      this.selectedStatus = statusList.filter(
        (s: any) => !this.EXCLUDED_STATUSES.includes(s.item_text)
      );
    });
  }

  intializeData(): void {
    this.userData = localStorage.getItem('user');
    if (this.userData) {
      this.loadUserEmail({ id: this.userData });
    }
  }

  loadProducts(
    postData: any = [],
    url: string = OSD_LOG_NEW
  ) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
          const buildList = (field: string) => {
            const seen = new Set<string>();
            return (this.products as any[])
              .map((p: any) => p[field])
              .filter((v: string) => v && !seen.has(v) && seen.add(v))
              .map((v: string) => ({ item_id: v, item_text: v }));
          };
          this.dropdownListPortfolioDirector = buildList('portfolio_director');
          this.dropdownListProjectManager = buildList('project_manager');
        } else {
          this.totalProducts = 0;
          this.dropdownListPortfolioDirector = [];
          this.dropdownListProjectManager = [];
        }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

    loadUserEmail(
    postData: { id: string },
    url: string = GET_USER_EMAIL
    ) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
      if (Array.isArray(data) && data.length > 0) {
        this.userEmail = data[0].user_name;
        this.loadProducts(this.createPostData());
      } else {
        console.warn('No user email found in response.');
      }
      });
  }

  createPostData() {
    return {
      userId: this.userId,
      productId: this.productId,
      userData: this.userData,
      userEmail: this.userEmail,
      changeDate: this.selectedChangeDate,
      status: this.selectedStatus.map((s: any) => s.item_text ?? s),
      productType: this.selectedProductType,
      bookType: this.selectedBookType,
      publishedDate: this.selectedPublishedDate,
      portfolioDirector: this.selectedPortfolioDirector,
      projectManager: this.selectedProjectManager,
      vertical: this.selectedVertical,
      page: this.currentPage,
    };
  }

  downloadReport() {
    this._requestService.download(
      OSD_LOG_NEW,
      {
        is_download: 1,
        userId: this.userId,
        userData: this.userData,
        productId: this.productId,
        userEmail: this.userEmail,
        changeDate: this.selectedChangeDate,
        status: this.selectedStatus.map((s: any) => s.item_text ?? s),
        productType: this.selectedProductType,
        bookType: this.selectedBookType,
        publishedDate: this.selectedPublishedDate,
        portfolioDirector: this.selectedPortfolioDirector,
        projectManager: this.selectedProjectManager,
        vertical: this.selectedVertical,
        page: this.currentPage,
      },
      '',
      'osd_log_new'
    );
  }

  updateSelectedType(event: any) {
    if (event.name == 'changeDate') {
      this.selectedChangeDate = event.selectedOption;
    }
    if (event.name == 'publishedDate') {
      this.selectedPublishedDate = event.selectedOption;
    }
  }

  updateSelectedDropDown(event: Event) {
    const data: any = event;

    if (data.type == 'status') {
      if (data.action == 'selected') {
        this.selectedStatus.push(data.item);
      } else if (data.action == 'deSelected') {
        const index = this.selectedStatus.findIndex((s: any) => s.item_id === data.item.item_id);
        if (index > -1) this.selectedStatus.splice(index, 1);
      } else if (data.action == 'deSelectedAll') {
        this.selectedStatus = [];
      }
    }

    if (data.type == 'productType') {
      if (data.action == 'selected') {
        this.selectedProductType.push(data.item.item_text);
      } else if (data.action == 'deSelected') {
        const index = this.selectedProductType.indexOf(data.item.item_text);
        if (index > -1) this.selectedProductType.splice(index, 1);
      } else if (data.action == 'deSelectedAll') {
        this.selectedProductType = [];
      }
    }

    if (data.type == 'bookType') {
      if (data.action == 'selected') {
        this.selectedBookType.push(data.item.item_text);
      } else if (data.action == 'deSelected') {
        const index = this.selectedBookType.indexOf(data.item.item_text);
        if (index > -1) this.selectedBookType.splice(index, 1);
      } else if (data.action == 'deSelectedAll') {
        this.selectedBookType = [];
      }
    }

    if (data.type == 'portfolioDirector') {
      if (data.action == 'selected') {
        this.selectedPortfolioDirector.push(data.item.item_text);
      } else if (data.action == 'deSelected') {
        const index = this.selectedPortfolioDirector.indexOf(data.item.item_text);
        if (index > -1) this.selectedPortfolioDirector.splice(index, 1);
      } else if (data.action == 'deSelectedAll') {
        this.selectedPortfolioDirector = [];
      }
    }

    if (data.type == 'projectManager') {
      if (data.action == 'selected') {
        this.selectedProjectManager.push(data.item.item_text);
      } else if (data.action == 'deSelected') {
        const index = this.selectedProjectManager.indexOf(data.item.item_text);
        if (index > -1) this.selectedProjectManager.splice(index, 1);
      } else if (data.action == 'deSelectedAll') {
        this.selectedProjectManager = [];
      }
    }

    if (data.type == 'vertical') {
      if (data.action == 'selected') {
        this.selectedVertical.push(data.item.item_text);
      } else if (data.action == 'deSelected') {
        const index = this.selectedVertical.indexOf(data.item.item_text);
        if (index > -1) this.selectedVertical.splice(index, 1);
      } else if (data.action == 'deSelectedAll') {
        this.selectedVertical = [];
      }
    }
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log('OSD Log Search Payload:', this.createPostData());
    this.loadProducts(this.createPostData());
    this.searchBtnText = 'Search';
    this.showSearchLoading = false;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    this.productId = '';
    this.selectedPortfolioDirector = [];
    this.selectedProjectManager = [];
    this.selectedVertical = [];
    this.selectedStatus = [];
    this.selectedProductType = [];
    this.selectedBookType = [];
    this.selectedPublishedDate = '';
    this.currentPage = 1;
    this.selectedChangeDate = 'last 1 year';
    this.intializeData();
    this.clearAllDropDowns();
    this.DropDownComponents.forEach((comp) => comp.clearAllSelection());
    // restore default status selection after clearAllSelection resets it to []
    this.selectedStatus = this.dropdownListStatus.filter(
      (s: any) => !this.EXCLUDED_STATUSES.includes(s.item_text)
    );
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((comp) => comp.clearInput());
  }

}
